import { render, staticRenderFns } from "./NormalSearchNav523.vue?vue&type=template&id=ef60a5f2&scoped=true"
import script from "./NormalSearchNav523.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav523.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef60a5f2",
  null
  
)

export default component.exports